<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle">診断コース登録</h1>
      <div class="l-contentsBox">
        <table class="l-form-table">
          <caption>診断コースマスタ</caption>
          <tr>
            <th class="v-middle"><span>診断コース名</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.inputForm.$model.courseName" @input="$v.inputForm.$touch()" />
                <ValidationErrorMessage v-show="$v.inputForm.courseName.$error && !$v.inputForm.courseName.required" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>表示用設問数</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.inputForm.$model.questionCountText" placeholder='例: 50問' @input="$v.inputForm.$touch()" />
                <ValidationErrorMessage v-show="$v.inputForm.questionCountText.$error && !$v.inputForm.questionCountText.required" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>説明</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextArea v-model="$v.inputForm.$model.description" @input="$v.inputForm.$touch()" class="l-formGroup__textArea" />
                <ValidationErrorMessage v-show="$v.inputForm.description.$error && !$v.inputForm.description.required" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>オプション監査</span></th>
            <td class="v-middle">
              <table class="l-form-table diag-section-table" style="margin-bottom:0px;border:none;">
                <tr>
                  <td style="border:none;">
                    <label class="l-checkbox">
                      <CheckBox v-model="$v.inputForm.$model.isOptionDiag" :value="true" :disabled="!inputable" :checked="inputForm.isOptionDiag" @change="changeIsOptionDiag()" labelText="オプション監査とする" />
                    </label>
                    <span class="icon-help"
                      data-tooltip=""
                      @mouseover="toggle('isOptionDiag')" @mouseleave="toggleb('isOptionDiag')">
                      <span id="isOptionDiag" class="tooltip is-right llong">
                        ・コース選択でオプション監査欄に表示されるようになります。<br>・カルテと監査トップで円グラフが表示されなくなる。<br>・「料金プラン(オプション)」にチェックを入れた場合のみ、この監査の新規作成が可能となります。
                      </span><img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
                    </span>
                    <transition name="slide">
                      <div class="child" v-if="inputForm.isOptionDiag" style="padding-left:20px;">
                        <ul>
                          <label class="l-checkbox">
                            <CheckBox v-model="$v.inputForm.$model.sectionNotUseFlag" :value="true" :disabled="!inputable" :checked="inputForm.sectionNotUseFlag" labelText="監査フォームで条を非表示とする/達成度グラフを非表示とする" />
                          </label>
                        </ul>
                        <ul>
                          <label class="l-checkbox">
                            <CheckBox v-model="$v.inputForm.$model.isStandardDiag" :value="true" :disabled="!inputable" :checked="inputForm.isStandardDiag" labelText="オプション契約不要" />
                          </label>
                          <span class="icon-help"
                            data-tooltip=""
                            @mouseover="toggle('isStandardDiag')" @mouseleave="toggleb('isStandardDiag')">
                            <span id="isStandardDiag" class="tooltip is-right llong">
                              簡易版用の設定項目です。<br>・法人一覧＞基本情報で「料金プラン(オプション)」に表示されなくなります。<br>・コース選択で標準版と同じエリアに表示されるようになります。
                            </span><img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
                          </span>
                        </ul>
                        <ul>
                          <label class="l-checkbox">
                            <CheckBox v-model="$v.inputForm.$model.isIpo" :value="true" :disabled="!inputable" labelText="IPO版とする" />
                          </label>
                        </ul>
                      </div>
                    </transition>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>表示順</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.inputForm.$model.sortOrder" @input="$v.inputForm.$touch()" />
                <ValidationErrorMessage v-show="$v.inputForm.sortOrder.$error && !$v.inputForm.sortOrder.required" validation="required" />
                <ValidationErrorMessage v-show="$v.inputForm.sortOrder.$error && !$v.inputForm.sortOrder.numeric" validation="numeric" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>表示する料金プラン</span></th>
            <td class="v-middle">
              <label class="l-checkbox">
                <CheckBox v-model="$v.inputForm.$model.isDisplayPricePlan2" :value="true" :checked="inputForm.isDisplayPricePlan2" labelText="社労士" />
              </label>
              <label class="l-checkbox">
                <CheckBox v-model="$v.inputForm.$model.isDisplayPricePlan3" :value="true" :checked="inputForm.isDisplayPricePlan3" labelText="代理店" />
              </label>
            </td>
          </tr>
        </table>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()"><a>登録</a></div>
        </div>
      </div>

      <div class="l-contentsBox" v-if="diag != null && diag.diagSections.length > 0">
        <table class="l-form-table diag-section-table" v-if="inputForm.verId">
          <caption>診断項目</caption>
          <template v-for="diagSection in diag.diagSections">
            <tr v-for="(diagSubSection, index) in diagSection.diagSubSections" :key="diagSubSection.subSectionId">
              <th v-if="index === 0" :rowspan="diagSection.diagSubSections.length">{{ diagSection.sectionNm }}</th>
              <td>
                <span class="link-arrow" @click="diagSubSection.isShow = !diagSubSection.isShow">{{ diagSubSection.subSectionNm }}</span>
                <transition name="slide">
                  <div class="child" v-if="diagSubSection.isShow">
                    <section v-for="diagItem in diagSubSection.diagItems" :key="diagItem.itemId">
                      <label class="l-checkbox">
                        <CheckBoxForSelect :id="diagItem.itemId" :value="diagItem.itemId"
                          :checked="diagItem.diagCourseItem.itemId"
                          @check-input="checkItemId"
                          :labelText="diagItem.checkItem" />
                      </label>
                    </section>
                  </div>
                </transition>
              </td>
            </tr>
          </template>
        </table>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()"><a>登録</a></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import CheckBoxForSelect from '@/components/parts/form/CheckBoxForSelect.vue';
import { required, numeric } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import CheckBox from '@/components/parts/form/CheckBox.vue';

export default {
  components: {
    Loading,
    TextBox,
    TextArea,
    CheckBoxForSelect,
    ValidationErrorMessage,
    CheckBox,
  },
  data() {
    return {
      isProcessing: false,
      isChangeVer: false,
      inputForm: {
        verId: null,
        courseName: null,
        questionCountText: null,
        description: null,
        sortOrder: null,
        isOptionDiag: false,
        isStandardDiag: false,
        isDisplayPricePlan2: false,
        isDisplayPricePlan3: false,
        isIpo: false,
        sectionNotUseFlag: false,
      },
      diagVerList: [],
      diag: {
        diagSections: [
          {
            diagSectionId: null,
            diagSubSections: [
              {
                subSectionId: null,
                diagItems: [
                  {
                    itemId: null,
                    diagCourseItem: {
                      itemId: null
                    }
                  }
                ],
              }
            ]
          }
        ]
      },
      selectItemIds: [],
      inputable: true,
    }
  },
  validations: {
    inputForm: {
      courseName: { required },
      questionCountText: { required },
      description: { required },
      sortOrder: { required, numeric },
    },
    selectItemIds: {}
  },
  computed: {
    diagCourseId() {
      return this.$store.getters['master/getDiagCourseId'];
    }
  },
  created: async function () {
    await this.getDiagCourse(this.diagCourseId);
    await this.changeDiagVer(this.inputForm.verId);
  },
  methods: {
    changeIsOptionDiag(){
      // is_option_diagの値が変更されたときは連動してfalseにする
      this.inputForm.sectionNotUseFlag = false;
      this.inputForm.isStandardDiag = false;
      this.inputForm.isIpo = false;
    },
    toggle(id) {
      var tooltip = $('#'+id);
      tooltip.fadeIn(200);
    },
    toggleb(id) {
      var tooltip = $('#'+id);
      tooltip.fadeOut(200);
    },
    async getDiagCourse(diagCourseId) {
      this.isProcessing = true;
      var res = await this.$axios.post('/ld/api/master/diagCourse/getDiagCourse', {
        diagCourseId: diagCourseId,
      });
      if (res) {
        this.inputForm = res.data.diagCourse;
        this.diagVerList = res.data.diagVerList;
        this.diag = res.data.diag;
        this.selectItemIds = res.data.selectItemIds;
        this.inputable = res.data.inputable;
      }
      this.isProcessing = false;
    },
    async changeDiagVer(verId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/diagCourse/getDiag', {
        verId: verId,
        diagCourseId: this.diagCourseId
      });
      if (res) {
        this.diag = res.data.diag;
      }
      this.isProcessing = false;
    },
    checkItemId(params) {
      if (params.checked) {
        this.selectItemIds.push(params.value);
      } else {
        this.selectItemIds = this.selectItemIds.filter(v => v != params.value);
      }
    },
    async register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/master/diagCourse/store', {
          diagCourseId: this.diagCourseId,
          diagCourse: this.inputForm,
          selectItemIds: this.selectItemIds,
        });
        if (res.status === 200) {
          this.$store.dispatch('alert/setMessage', '登録が完了しました');
          this.$store.dispatch('master/setDiagCourseId', null);
          this.$router.push({ name: 'diag-course-list' });
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    }
  },
}

</script>

<style scoped>
.diag-section-table {
  border: solid #dcdcdc 1px;
}

.diag-section-table th {
  background: #fff;
  border: solid #dcdcdc 1px;
}

.diag-section-table td {
  padding-left: 10px;
  border: solid #dcdcdc 1px;
}

.diag-section-table td span{
  cursor: pointer;
}

.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}

</style>
